var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M5.77 20C4.793 20 4 19.105 4 18V6c0-1.105.793-2 1.77-2h2.656c.977 0 1.77.895 1.77 2v12c0 1.105-.793 2-1.77 2zM15.575 20c-.978 0-1.77-.895-1.77-2V6c0-1.105.792-2 1.77-2h2.655c.977 0 1.77.895 1.77 2v12c0 1.105-.793 2-1.77 2z"
  })));
};
export default SvgPause;